// 首付比五档：A 为 [0,20]，其余档位为 (minValue,maxValue]。
// 绿到红表示首付比数值递增，沿用已确认的配色。
export const PrepayLevelList = Object.freeze(
  [
    { name: "A", minValue: 0, maxValue: 20, color: "#28D576" },
    { name: "B", minValue: 20, maxValue: 30, color: "#1483EA" },
    { name: "C", minValue: 30, maxValue: 40, color: "#3FD0C9" },
    { name: "D", minValue: 40, maxValue: 50, color: "#FFAC46" },
    { name: "E", minValue: 50, maxValue: 60, color: "#D05252" },
  ].map((item) => Object.freeze(item)),
);

const PrepayLevelColorMap = new Map(
  PrepayLevelList.map((item) => [item.name, item.color]),
);

// 未知等级使用中性灰。
export const PrepayLevelUnknownColor = "#DCDFE6";

// 按等级返回配色，未知等级返回兜底色。
export function getPrepayLevelColor(level) {
  return PrepayLevelColorMap.get(level) || PrepayLevelUnknownColor;
}

// 按首付比查档，缺失、无效或超出 0～60 时返回 null。
export function getPrepayLevelByRate(rate) {
  if (
    rate === null ||
    rate === undefined ||
    (typeof rate !== "number" && typeof rate !== "string") ||
    (typeof rate === "string" && rate.trim() === "")
  )
    return null;
  const num = Number(rate);
  if (!Number.isFinite(num)) return null;
  return (
    PrepayLevelList.find(
      (item, index) =>
        num <= item.maxValue &&
        (index === 0 ? num >= item.minValue : num > item.minValue),
    ) || null
  );
}
